<template>
  <div class="search-products">

      <div class="input-group">
        <div class="input-group-btn" :class="{ open: openPlusMenu }">
          <button type="button" class="btn-list-detail" 
                  @click="openPlusMenu=!openPlusMenu">&#10010;
          </button>

          <ul class="dropdown-menu dropdown-menu-left">
            <li><a href="#" id="selector-simple-item"
              @click="requestDetailChange('product-item')">Краткая характеристика
            <span class="glyphicon glyphicon-ok"
              v-if="myItemComponent==='product-item'">&#10004;</span></a></li>

            <li><a href="#" id="selector-detail-item"
              @click="requestDetailChange('product-item-detail')">Подробно
            <span class="glyphicon glyphicon-ok"
              v-if="myItemComponent==='product-item-detail'">&#10004;</span></a></li>
          </ul>
        </div>

        <div class="input-group-search">
          <input id="search-products" placeholder="Отфильтровать" type="text"  class="input-search" aria-label="Search Products" 
          v-model="searchTerm" />
        </div>

        <div class="input-group-btn" :class="{ open: openSortByMenu }">
          <button type="button" class="btn-order" 
                  @click="openSortByMenu=!openSortByMenu">Сортировка
          </button>

          <ul class="dropdown-menu dropdown-menu-right">
            <li><a href="#" id="product-mpn"
              @click="requestKeyChange('mpn')">По артикулу
            <span class="glyphicon glyphicon-ok"
              v-if="myKey==='mpn'">&#10004;</span></a></li>

            <li><a href="#" id="product-name-ru"
              @click="requestKeyChange('nameRU')">По наименованию
            <span class="glyphicon glyphicon-ok"
              v-if="myKey==='nameRU'">&#10004;</span></a></li>

            <li><a href="#" id="product-price"
              @click="requestKeyChange('price')">По цене
              <span class="glyphicon glyphicon-ok"
              v-if="myKey==='price'">&#10004;</span></a></li>

            <li><a href="#" id="product-width"
              @click="requestKeyChange('width')">По ширине
              <span class="glyphicon glyphicon-ok"
              v-if="myKey==='width'">&#10004;</span></a></li>

            <li><a href="#" id="product-depth"
              @click="requestKeyChange('depth')">По глубине
              <span class="glyphicon glyphicon-ok"
              v-if="myKey==='depth'">&#10004;</span></a></li>

            <li><a href="#" id="product-height"
              @click="requestKeyChange('height')">По высоте
              <span class="glyphicon glyphicon-ok"
              v-if="myKey==='height'">&#10004;</span></a></li>

            <li role="separator" class="divider"></li>

            <li><a href="#" id="asc"
              @click="requestDirChange('asc')">По возрастанию
              <span class="glyphicon glyphicon-asc"
                v-if="myDir==='asc'">&#10004;</span></a></li>

            <li><a href="#" id="desc"
              @click="requestDirChange('desc')">По убыванию
              <span class="glyphicon glyphicon-desc"
                v-if="myDir==='desc'">&#10004;</span></a></li>
          </ul>

        </div><!-- input-group-btn --> 

      </div><!-- input-group --> 

  </div><!-- search-products -->
</template>

<script>
export default {

  name: 'SearchProducts',
  data() {
    return {
      searchTerm: '',
      openPlusMenu: false,
      openSortByMenu: false
    } //return
  }, //data

  watch: {
    searchTerm: function() {
      this.$emit('searchRecords', this.searchTerm);
    } //searchTerm
  }, //watch

  props: ['myItemComponent', 'myKey', 'myDir'],

  methods: {

    requestDetailChange: function(value) {
      this.openPlusMenu = !this.openPlusMenu;
      this.$emit('detailChange', value);
    }, //requestListDetailChange

    requestKeyChange: function(value) {
      this.openSortByMenu = !this.openSortByMenu;
      this.$emit('keyChange', value);
    }, //requestKeyChange

    requestDirChange: function(value) {
      this.openSortByMenu = !this.openSortByMenu;
      this.$emit('dirChange', value);
    } //requestKeyChange

  }

} // export
</script>

<style scoped>
  button, input, optgroup, select, textarea {
    margin: 0px;
    font: inherit;
    color: inherit;
  }
  .input-group {
    position: relative;
    display: table;
    border-collapse: separate;
    margin: 0 auto;
    width: 94%;
  }
  .input-group .input-group-search {
    display: table-cell;
    position: relative;
    width: 100%;
    margin: 0;
    /* height: 34px; */
    padding: 6px 12px;
    font-size: 16px;
    line-height: 1.5;
    color: #888;
    background-color: #fff;
    background-image: none;
    border: 1px solid #f04958;
    border-radius: 0;
    /* border-radius: 8px 0 0 8px; */
    /* -webkit-box-shadow: inset 0 2px 2px rgba(0,0,0,.075); */
    /* box-shadow: inset 0 2px 2px rgba(0,0,0,.075); */
    -webkit-transition: border-color ease-in-out .15s,-webkit-box-shadow ease-in-out .15s;
    -o-transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;
    transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;
  }
  .input-group .input-search {
    width: 100%;
    border: 0;
  }
  .input-group .input-group-search:focus {
    outline: 0;
    /*
      border-color: #f04958;
      -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(240,73,88,.6);
      box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(240,73,88,.6);
    */
  }
  .input-group .input-group-btn {
    display: table-cell;
    width: 1%;
    position: relative;
    font-size: 0;
    white-space: nowrap;
  }
  .input-group .input-group-btn .btn-order,
  .input-group .input-group-btn .btn-list-detail {
    color: #fff;
    background-color: #f04958;
    border-color: #f04958;
    display: inline-block;
    padding: 6px 12px;
    margin-bottom: 0;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.5;
    text-align: center;
    white-space: nowrap;
    _vertical-align: middle;
    -ms-touch-action: manipulation;
    touch-action: manipulation;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    background-image: none;
    border: 1px solid #f04958;
    border-radius: 0 8px 8px 0;
  }
  .input-group .input-group-btn .btn-list-detail {
    border-radius: 8px 0 0 8px;
    font-size: 16px;
    font-weight: bold;
    width: 100%; /* обязательно, иначе будет промежуток */
  }
  .dropdown-menu {
    position: absolute;
    top: 100%;
    z-index: 1000;
    display: none;
    min-width: 160px;
    padding: 5px 0;
    margin: 2px 0 0;
    font-size: 14px;
    text-align: left;
    list-style: none;
    background-color: #fff;
    -webkit-background-clip: padding-box;
    background-clip: padding-box;
    border: 1px solid #ccc;
    border: 1px solid rgba(0,0,0,.15);
    border-radius: 4px;
    -webkit-box-shadow: 0 6px 12px rgba(0,0,0,.175);
    box-shadow: 0 6px 12px rgba(0,0,0,.175);
  }
  .dropdown-menu-left {
    left: 0;
    right: auto;
    float: right;
  }
  .dropdown-menu-right {
    right: 0;
    left: auto;
    float: left;
  }
  .open>.dropdown-menu {
    display: block;
  }
  .dropdown-menu>li>a {
    display: block;
    padding: 3px 20px;
    clear: both;
    font-weight: 400;
    line-height: 1.5;
    color: #333;
    white-space: nowrap;
  }
  .dropdown-menu>li>a:focus, .dropdown-menu>li>a:hover {
    color: #262626;
    text-decoration: none;
    background-color: #f5f5f5;
  }
  .dropdown-menu .divider {
    height: 1px;
    margin: 9px 0;
    overflow: hidden;
    background-color: #e5e5e5;
  }
  .glyphicon { 
    margin-left: 0.5em;
    font-size: 1.2em;
    color: #f04958;
  }

  @media (min-width: 480px) {
    .input-group {
        width: 90%;
    }
  }
  @media (min-width: 640px) {
    .input-group {
        width: 80%;
    }
  }
  @media (min-width: 960px) {
    .input-group {
        width: 60%;
    }
  }

</style>



// WEBPACK FOOTER //
// src/SearchProducts.vue